export const GET_TOTAL_FEEDBACKS = 'GET_TOTAL_FEEDBACKS'
export const GET_TOTAL_CUSTOMER = 'GET_TOTAL_CUSTOMER'
export const GET_TOTAL_LOYALITY = 'GET_TOTAL_LOYALITY'
export const GET_TOTAL_CAMPAIGN = 'GET_TOTAL_CAMPAIGN'
export const GET_TOTAL_REFFERALS = 'GET_TOTAL_REFFERALS'
export const GET_TOTAL_NEGATVIE_FEEDBACK = 'GET_TOTAL_NEGATVIE_FEEDBACK'
export const GET_UPCOMING_EVENTS = 'GET_UPCOMING_EVENTS'
export const GET_WEIGHTED_GRAPH = 'GET_WEIGHTED_GRAPH'
export const GET_NON_WEIGHTED_GRAPH = 'GET_NON_WEIGHTED_GRAPH'
export const GET_FEEDBACK_FORM_TYPE = 'GET_FEEDBACK_FORM_TYPE'
export const GET_SATISFACTION_SCORE = 'GET_SATISFACTION_SCORE'
export const GET_RETENTION_SCORE = 'GET_RETENTION_SCORE'
export const GET_CLIENT_SUBSCRIPTION_STATUS = "GET_CLIENT_SUBSCRIPTION_STATUS";
export const GET_TOTAL_RESPONSES_WIDGET = 'GET_TOTAL_RESPONSES_WIDGET'
export const GET_CSAT_WIDGET = 'GET_CSAT_WIDGET'
export const GET_NPS_WIDGET = 'GET_NPS_WIDGET'
export const GET_AT_RISK_WIDGET = 'GET_AT_RISK_WIDGET'
export const GET_SENTIMENT_MIX_WIDGET = 'GET_SENTIMENT_MIX_WIDGET'
export const GET_TICKET_SUMMARY_WIDGET = 'GET_TICKET_SUMMARY_WIDGET'
export const GET_RECENT_NEGATIVE_COMMENTS_WIDGET = 'GET_RECENT_NEGATIVE_COMMENTS_WIDGET'
export const GET_LOCATION_COMPARISON_WIDGET = 'GET_LOCATION_COMPARISON_WIDGET'
export const GET_NEGATIVE_THEMES_WIDGET = 'GET_NEGATIVE_THEMES_WIDGET'
export const GET_COMPLAINT_CATEGORIES_WIDGET = 'GET_COMPLAINT_CATEGORIES_WIDGET'
export const GET_NPS_TREND_WIDGET = 'GET_NPS_TREND_WIDGET'
export const GET_SATISFACTION_TREND_WIDGET = 'GET_SATISFACTION_TREND_WIDGET'